import mixpanel from 'mixpanel-browser'
import * as Sentry from '@sentry/react'

export const shouldTrack = () =>
  ['production', 'staging'].includes(process.env.NODE_ENV || 'staging')

export const getIgnoredErrorsStaging = () =>
  process.env.NODE_ENV === 'staging' ? ['ChunkLoadError'] : []

export enum AnalyticsEvent {
  // Login Page
  LoginError = 'Clicked: Login Error',
  LoginSuccess = 'Clicked: Login Success',

  // View Events
  PageView = 'Viewed: Page',

  // Reports Events
  ReportsExportData = 'Clicked: Export Data',
  ReportsChooseAsset = 'Clicked: Choose asset type view',
  ReportsChooseGate = 'Selected: Gate',
  ReportsEntryType = 'Selected: Entry type',
  ReportsClickedRow = 'Clicked: Row',
  ReportsTableSettings = 'Clicked: Table Settings',
  ReportsRowPicture = 'Clicked: Row Picture',

  // Gate Feed Events
  ReportsAddTransaction = 'Clicked: Add Transaction',
  ReportsSearchTransaction = 'Searched: Transaction',
  ReportsUpdateTransaction = 'Updated: Transaction Details',
  ReportsNewTransaction = 'Added: New Transaction',

  // Yard Inventory Events
  ReportsAddAsset = 'Clicked: Add Asset',
  ReportsSearchAsset = 'Searched: Asset',
  ReportsUpdateAsset = 'Updated: Asset Details',
  ReportsNewAsset = 'Added: New Asset',

  // Sidebar events
  GateFeedView = 'Clicked: Gate Feed',
  YardInventoryView = 'Clicked: Yard Inventory',
  AnalyticsView = 'Clicked: Analytics',
}

export enum AnalyticsEventTrigger {
  click = 'click',
  select = 'select',
  redirect = 'redirect',
  success = 'success',
  error = 'error',
  hover = 'hover',
  view = 'view',
}

function setMixPanelUser(userData: any): void {
  const { email, name, companyId } = userData
  mixpanel.identify(email)
  mixpanel.register(userData)
  mixpanel.people.set({
    id: email,
    $email: email,
    $name: name,
    $companyId: companyId,
  })
}

export default {
  init: () => {
    if (!shouldTrack()) {
      return
    }
    mixpanel.init(process.env.MIXPANEL_TOKEN)
    Sentry.init({ dsn: process.env.SENTRY_DSN, environment: process.env.NODE_ENV })
  },
  setUser: (user: { email?: string; id: string; name?: string; companyId?: string }) => {
    if (!shouldTrack() || !user) {
      return
    }
    setMixPanelUser(user)
    Sentry.setUser(user)
  },
  track: (
    event: AnalyticsEvent,
    trigger = 'click',
    props: Record<string, any> = { trigger: '' }
  ) => {
    if (!shouldTrack()) {
      // eslint-disable-next-line no-console
      console.log(`analytics.track('${event}', ${trigger}, ${JSON.stringify(props)})`)
      return
    }
    props.trigger = trigger
    mixpanel.track(event, props)
    console.log(event, { ...props, metric_type: event })
  },
  reset: () => {
    if (!shouldTrack()) {
      return
    }
    mixpanel.reset()
  },
}
